import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'mpp-hipaa-cancel-warning-dialog',
  templateUrl: './hipaa-cancel-warning-dialog.component.html',
  styleUrls: ['./hipaa-cancel-warning-dialog.component.scss'],
  standalone: false,
})
export class HipaaCancelWarningDialogComponent {
  constructor(public dialogRef: MatDialogRef<HipaaCancelWarningDialogComponent>) {}

  onContinue(): void {
    // Return false = user wants to stay and complete HIPAA
    this.dialogRef.close(false);
  }

  onLogout(): void {
    // Return true = user wants to log out
    this.dialogRef.close(true);
  }
}
